export const GENERAL_COMPETENCY_EVENT_STATUSES = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};
